export const FTM_CHAIN_ID=process.env.REACT_APP_FTM_CHAIN_ID as string